import Rollbar from '../Rollbar';

const level = {
  DEBUG: 3,
  INFO: 2,
  WARN: 1,
};

const logFn = name => {
  if (!console) {
    return () => {};
  }
  return typeof console[name] === 'function'
    ? console[name].bind(console)
    : console.log.bind(console);
};

class Logger {
  constructor() {
    // default log level, errors always shown
    this.level = level.INFO;

    this.setSessionId = this.setSessionId.bind(this);
    this.setLogLevel = this.setLogLevel.bind(this);

    this.info = this.info.bind(this);
    this.debug = this.debug.bind(this);
    this.warn = this.warn.bind(this);
    this.error = this.error.bind(this);
    this.critical = this.critical.bind(this);

    this._rollbar = new Rollbar(this);
  }
  setSessionId(sessionId) {
    this.sessionId = sessionId;
    this._rollbar.setSessionId(sessionId);
  }
  setLogLevel(logLevel) {
    const lvl = logLevel.toLowerCase();
    if (lvl === 'info') {
      this.level = level.INFO;
    } else if (lvl === 'debug') {
      this.level = level.DEBUG;
    } else if (lvl === 'warn') {
      this.level = level.WARN;
    }
  }
  log(...args) {
    logFn('log')(...args);
  }
  debug(...args) {
    if (this.level >= level.DEBUG) {
      const log = logFn('debug');
      log(...args);
    }
  }
  info(...args) {
    if (this.level >= level.INFO) {
      const log = logFn('info');
      log(...args);
    }
  }
  warn(msg_or_exc, options = {}) {
    if (this.level >= level.WARN) {
      const log = logFn('warn');
      log(msg_or_exc, options);
      this._rollbar.log(msg_or_exc, Object.assign({}, options, { level: 'warning' }));
    }
  }
  error(msg_or_exc, options = {}) {
    const log = logFn('error');
    log(msg_or_exc, options);
    this._rollbar.log(msg_or_exc, Object.assign({}, options, { level: 'error' }));
  }
  critical(msg_or_exc, options = {}) {
    const log = logFn('error');
    log(msg_or_exc, options);
    this._rollbar.log(msg_or_exc, Object.assign({}, options, { level: 'critical' }));
  }
}

if (!global.logger) {
  global.logger = new Logger();
}

export default global.logger;



// WEBPACK FOOTER //
// ./src/utils/Logger/index.js